import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  Platform,
  KeyboardAvoidingView,
  View,
  RefreshControl,
  Image,
  TouchableOpacity,
  ActivityIndicator,
  Modal,
  // Picker,
} from 'react-native';
import {
  Button, Input, Text, registerCustomIconType,
} from 'react-native-elements';
// import { ifIphoneX } from 'react-native-iphone-x-helper';
// import Geolocation from '@react-native-community/geolocation';
import Icon from 'react-native-vector-icons/dist/FontAwesome';
import { Formik } from 'formik';
import { object as yupObject } from 'yup';
import { compressToBase64 } from 'lz-string';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';

// import { AudioFullPlayer } from '../../../audio-player';
import PendingImage from '../../misc/PendingImage';
import { translate } from '../../../locales/i18n';
import AORTypes from '../../../types';
import styles from '../../../styles';
import {
  nameValidation,
  extraStayValidation,
} from '../../../modules/validation/Endpoint';
import App from '../../../modules/data/App';
import Endpoint from '../../../modules/data/Endpoint';
import Uploader from '../../../Uploader';
// import TimePicker from '../../../../../misc/client/components/misc/TimePicker';
// import record from '../../../assets/images/glyphicons-microphone.png';
// import upload from '../../../assets/images/glyphicons-upload.png';
// import UpdateEndpoint from '../../../q/UpdateEndpoint';
import Slider from '../../misc/VerticalSlider';
import ScrollFading from '../../effects/ScrollFading';
// import { fixGoogleMapsWebStyles } from '../../../modules/Utils';

// import createConfig from '../../../config.json';
import miscConfig from '../../../config.json';

registerCustomIconType('font-awesome-5', FontAwesome5);

const validationSchema = yupObject().shape({
  name: nameValidation,
  extraStay: extraStayValidation,
});

const mapTypeMap = Platform.OS === 'web' ? 'roadmap' : 'standard';
const mapTypeSatellite = 'hybrid';

class PublisherEndpointForm extends React.Component {
  static getImage(image) {
    if (image.thumb) {
      return { uri: image.thumb };
    }

    const str = image.uuid;
    // FIXME(clairbee): why 8 6 4 2, and not 2 2 2 2 ???
    const prefix = str.substring(6, 8)
      + str.substring(4, 6)
      + str.substring(2, 4)
      + str.substring(0, 2);
    // const prefix = data.uuid.substring(0, 8);
    // console.log(prefix);
    let index = parseInt(prefix, 16) % 100;
    index += 100;
    index = index.toString().substr(-2, 2);

    return { uri: `https://${miscConfig.imagesThumbsBucket}.s3-${miscConfig.region}.amazonaws.com/${index}/${str}` };
  }

  constructor(props, context) {
    super(props, context);

    this.onRegionChangeComplete = this.onRegionChangeComplete.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleDeleteReal = this.handleDeleteReal.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);

    // const { endpoint, position } = this.props;

    // console.log('endpoint');
    // console.log(endpoint);

    this.state = {
      mapType: mapTypeMap,
      error: '',
      refreshing: false,
      uploading: false,
      isDeleting: false,
    };
  }

  componentDidMount() {
    this.updatePlaylist(this.state);
  }

  componentDidUpdate(_prevProps, prevState) {
    this.updatePlaylist(prevState);
  }

  handleRefresh() {
    const { onRefresh } = this.props;
    this.setState({ refreshing: true });

    onRefresh().then(() => {
      this.setState({ refreshing: false });
    });
  }

  handleCancel(_values, _formikBag) {
    const { onCancel } = this.props;

    onCancel();
  }

  handleDelete(_values, _formikBag) {
    this.setState({ isDeleting: true });
  }

  handleDeleteReal() {
    const { onDel } = this.props;

    onDel();
  }

  handleSave(values, formikBag) {
    const {
      onSave, onCancel, onDel, onNext,
      getAnalyticsService,
    } = this.props;

    if (onDel !== undefined) {
      // this is 'edit'
      getAnalyticsService().report.event('endpointEditAttempt', 'create');
    } else {
      // this is 'add'
      getAnalyticsService().report.event('endpointAddAttempt', 'create');
    }

    formikBag.setSubmitting(true);

    const vals = values;
    vals.extraStay = Number.parseInt(values.extraStay, 10);
    onSave(vals).then((result) => {
      console.log('result');
      console.log(result);
      if (onDel !== undefined) {
        // this is 'edit'
        getAnalyticsService().report.event('endpointEditSuccess', 'create');
        onCancel();
      } else if (result.data !== undefined && result.data.createEndpoint !== undefined) {
        // this is 'add'
        getAnalyticsService().report.event('endpointAddSuccess', 'create');
        onNext(result.data.createEndpoint.uuid);
      }
    })
      .catch((err) => {
        formikBag.setStatus(err.message);
      });
  }

  updatePlaylist(prevState) {
    const { endpoint } = this.props;

    if (endpoint.data && endpoint.data.track) {
      if (prevState.playlistTrack !== endpoint.data.track) {
        Uploader.getToken().then((token) => {
          const playlist = [{
            url: endpoint.getTrackPublisher(token),
          }];

          // console.log('setting the playlist');
          // console.log(playlist);

          this.setState({ playlistTrack: endpoint.data.track, playlist });
        });
      }
    } else if (prevState.playlistTrack !== '') {
      this.setState({ playlistTrack: '', playlist: [] });
    }
  }

  renderForm = ({
    isValid,
    values,
    handleSubmit,
    setFieldValue,
    touched,
    errors,
    setFieldTouched,
    isSubmitting,
    status,
  }) => {
    const {
      onDel, onRefresh, getUploader, app, endpoint, history, direction, getDirectionsService,
      getAnalyticsService,
      onAddImage,
      onAddTrack,
    } = this.props;
    const {
      refreshing,
      uploading,
      mapType,
      isDeleting,
    } = this.state;

    // FIXME(clairbee): why is it needed here? why didn't it work in componentWillReceiveProps?
    app.postProcess();
    endpoint.postProcess();

    if (app.pp.endpoints && app.pp.endpoints.length > 1
      && touched.lat && touched.lon
      && (endpoint.pp.lat !== values.lat || endpoint.pp.lon !== values.lon)) {
      // use endpoint.pp to store the last values that were used to update the directions
      endpoint.pp.lat = values.lat;
      endpoint.pp.lon = values.lon;
      endpoint.data.lat = values.lat;
      endpoint.data.lon = values.lon;

      let found = false;
      for (let i = 0; i < app.pp.endpoints.length; i += 1) {
        if (app.pp.endpoints[i].uuid === endpoint.data.uuid) {
          app.pp.endpoints[i].lat = values.lat;
          app.pp.endpoints[i].lon = values.lon;
          found = true;
          break;
        }
      }
      if (!found) {
        console.log('adding the endpoint to the app for route calculation purposes');
        app.pp.endpointIds.push(endpoint.data.uuid);
        endpoint.data.lat = values.lat;
        endpoint.data.lon = values.lon;
        app.pp.endpoints.push(endpoint.data);
      }

      if (app.pp.travelType !== 3) {
        // TODO(clairbee): replace this with the manipulation of the state 'uploading'
        setFieldValue('workingOnSomething', true);
        setFieldTouched('workingOnSomething');

        setTimeout((async () => {
          const routeInfo = await getDirectionsService().getDirections(app);

          app.pp.route = routeInfo.route;
          setFieldValue('bounds', JSON.stringify(routeInfo.bounds));
          setFieldTouched('bounds');
          setFieldValue('legs', compressToBase64(JSON.stringify(routeInfo.legs)));
          setFieldTouched('legs');
          setFieldValue('route', compressToBase64(JSON.stringify(routeInfo.route)));
          setFieldTouched('route');
          setFieldValue('routeduration', routeInfo.routeduration);
          setFieldTouched('routeduration');
          setFieldValue('routelen', routeInfo.routelen);
          setFieldTouched('routelen');

          setFieldValue('workingOnSomething', false);
          setFieldTouched('workingOnSomething');
        }), 0);
      }
    }

    const mapRadius = 20;
    if (Platform.OS === 'web') {
      // fixGoogleMapsWebStyles(direction);
    }

    return (
      <View style={{
        flex: 1,
        flexDirection: direction,
        width: '100%',
      }}
      >
        <View
          style={{
            flex: 1,
            width: '100%',
          }}
        >
          <div>Map view was here</div>
          <View
            style={styles.map(direction).controlsTopRow}
          >
            <View style={styles.map(direction).controlContainer}>
              <Text
                style={styles.map(direction).mapTypeControl}
                onPress={() => {
                  this.setState({ mapType: mapType === mapTypeSatellite ? mapTypeMap : mapTypeSatellite });
                }}
              >
                {mapType === mapTypeSatellite ? translate('map_satellite') : translate('map_map')}
              </Text>
            </View>
          </View>
        </View>
        <View
          style={{
            flex: 1,
          }}
        >
          {/* Inner view that is responsible to get _ON TOP_ of the map */}
          <KeyboardAvoidingView
            style={[{
              backgroundColor: 'white',
              flexDirection: 'column',
              position: 'absolute',
              overflow: 'hidden',
              flex: 1,
            }, direction === 'column' ? {
              top: -mapRadius,
              bottom: 0,
              width: '100%',
              borderTopLeftRadius: mapRadius,
              borderTopRightRadius: mapRadius,
            } : {
              left: -mapRadius,
              right: 0,
              height: '100%',
              borderTopLeftRadius: mapRadius,
              borderBottomLeftRadius: mapRadius,
            }]}
            behavior={Platform.OS === 'ios' ? 'padding' : undefined}
          >
            <ScrollFading
              style={{
                flex: 1,
                width: '100%',
              }}
              refreshControl={onRefresh !== undefined ? (
                <RefreshControl refreshing={refreshing} onRefresh={this.handleRefresh} />
              ) : undefined}
            >
              <View
                style={{
                  alignItems: 'center',
                }}
              >
                {status !== undefined && (
                  <Text
                    style={{
                      color: 'red',
                    }}
                  >
                    {status}
                  </Text>
                )}
                <Input
                  containerStyle={styles.form.inputContainer}
                  labelStyle={styles.form.inputLabel}
                  inputStyle={styles.form.inputInput}
                  inputContainerStyle={touched.name && errors.name ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
                  label={`${translate('endpoint_name')}:`}
                  value={values.name}
                  placeholder={translate('endpoint_name_placeholder')}
                  // autoCapitalize="none"
                  onChangeText={(value) => setFieldValue('name', value)}
                  onBlur={() => setFieldTouched('name')}
                  errorMessage={touched.name && errors.name ? errors.name : undefined}
                  placeholderTextColor="grey"
                />
                {/* <Input
                  label={`${translate('endpoint_extra_stay')}:`}
                  value={values.extraStay ? `${values.extraStay}` : '0'}
                  onChange={(value) => setFieldValue('extraStay', value)}
                  onBlur={() => setFieldTouched('extraStay')}
                  errorMessage={touched.extraStay && errors.extraStay ? errors.extraStay : undefined}
                  labelStyle={{
                    marginBottom: 10,
                  }}
                  inputStyle={{
                    marginVertical: 6,
                  }}
                  inputComponent={TimePicker}
                /> */}
                <Input
                  containerStyle={styles.form.inputContainer}
                  labelStyle={styles.form.inputLabel}
                  inputStyle={styles.form.inputInput}
                  inputContainerStyle={touched.size && errors.size ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
                  label={`${translate('endpoint_size')}:`}
                  onBlur={() => setFieldTouched('size')}
                  errorMessage={touched.size && errors.size ? errors.size : undefined}
                  inputComponent={React.forwardRef((props, ref) => {
                    const { style, ...otherProps } = props; // eslint-disable-line
                    return (
                      <View
                        style={style}
                      >
                        <Slider
                          ref={ref}
                          onValueChange={(value) => {
                            console.log('onValueChange');
                            console.log(value);
                            setFieldValue('size', value);
                            setFieldTouched('size');
                          }}
                          initialValue={values.size ? values.size : 0}
                          margin={10}
                          min={-2}
                          max={4}
                          minColor="#333"
                          maxColor="#888"
                          barWidth={3}
                          horizontal
                          {...otherProps} // eslint-disable-line react/jsx-props-no-spreading
                        />
                      </View>
                    );
                  })}
                />
                {endpoint.data.uuid !== 1 ? (
                  <>
                    <View
                      style={{
                        flexDirection: 'row',
                        width: '100%',
                        maxWidth: 600,
                        marginTop: 15,
                      }}
                    >
                      {/* <Text style={{
                        textAlign: 'left',
                        textAlignVertical: 'center',
                      }}
                      >
                        {`${translate('endpoint_track')}:`}
                      </Text> */}
                      {Platform.OS === 'web' ? (
                        <View>
                          <form>
                            <input
                              type="file"
                              name="audiofile"
                              id="audiofile"
                              nesting="audiofile" // eslint-disable-line
                              accept="audio/*,.mp,.m4a,.mp3"
                              title={translate('endpoint_photo_upload')}
                              onChange={(e) => {
                                console.log('onChange');
                                getAnalyticsService().report.event('endpointTrackUploadWebAttempt', 'create');
                                this.setState({ uploading: true });
                                getUploader().handleWebUpload(
                                  'audiofile',
                                  endpoint.data.uuid,
                                  onAddTrack,
                                  null,
                                  (success) => {
                                    console.log('onComplete called');
                                    getAnalyticsService().report.event('endpointTrackUploadWebSuccess', 'create');
                                    console.log(success);
                                    onRefresh();
                                    this.setState({ uploading: false });
                                  },
                                  { app: endpoint.data.app, endpoint: endpoint.data.uuid },
                                  e
                                );
                              }}
                              style={{
                                width: '0.1px',
                                height: '0.1px',
                                opacity: '0',
                                overflow: 'hidden',
                                position: 'absolute',
                                zIndex: '-1',
                              }}
                            />
                            <label
                              id="label"
                              nesting="audiofile" // eslint-disable-line
                              htmlFor="audiofile"
                            >
                              {/* eslint-disable-line jsx-a11y/label-has-associated-control */}
                              <Button
                                // title={translate('endpoint_photo_upload')}
                                // title={translate('endpoint_photo_take')}
                                icon={(
                                  <Icon
                                    style={{ width: 24 }}
                                    name="microphone"
                                    size={24}
                                    color="white"
                                  />
                                )}
                                containerStyle={styles.button.primaryContainer}
                                buttonStyle={styles.button.primary}
                                disabledStyle={styles.button.primaryDisabled}
                                titleStyle={styles.button.primaryTitle}
                                disabledTitleStyle={styles.button.primaryTitleDisabled}
                                disabled={isSubmitting || !isValid}
                              />
                            </label>
                          </form>
                        </View>
                      ) : (
                        <Button
                          // title={translate('endpoint_photo_upload')}
                          // title={translate('endpoint_photo_take')}
                          icon={(
                            <Icon
                              style={{ width: 24 }}
                              name="microphone"
                              size={24}
                              color="white"
                            />
                          )}
                          containerStyle={styles.button.primaryContainer}
                          buttonStyle={styles.button.primary}
                          disabledStyle={styles.button.primaryDisabled}
                          titleStyle={styles.button.primaryTitle}
                          disabledTitleStyle={styles.button.primaryTitleDisabled}
                          onPress={(e) => {
                            getAnalyticsService().report.event('endpointTrackUploadMobileAttempt', 'create');
                            this.setState({ uploading: true });
                            setTimeout(() => {
                              getUploader().handleMobileAudioUpload(
                                'Select audio track',
                                endpoint.data.uuid,
                                onAddTrack,
                                null,
                                (success) => {
                                  console.log('onComplete called');
                                  getAnalyticsService().report.event('endpointTrackUploadMobileSuccess', 'create');
                                  console.log(success);
                                  onRefresh();
                                  this.setState({ uploading: false });
                                },
                                { app: endpoint.data.app, endpoint: endpoint.data.uuid },
                                e
                              );
                            }, 0);
                          }}
                          disabled={isSubmitting || !isValid}
                        />
                      )}
                      {/* <Button
                        title={translate('endpoint_track_upload')}
                        icon={(
                          <Icon
                            name="paperclip"
                            size={24}
                            color="white"
                          />
                        )}
                        containerStyle={styles.button.primaryContainer}
                        buttonStyle={styles.button.primary}
                        disabledStyle={styles.button.primaryDisabled}
                        titleStyle={styles.button.primaryTitle}
                        disabledTitleStyle={styles.button.primaryTitleDisabled}
                        onPress={this.handleTrackUpload}
                        disabled={isSubmitting}
                      /> */}
                      {/* <AudioPlayer
                        playlist={[{
                          url: 'http://www.hochmuth.com/mp3/Tchaikovsky_Rococo_Var_orch.mp3',
                          title: 'AudioTrack',
                        }]}
                        autoplay
                        style={{ position: 'static', width: 220 }}
                        controls={['playpause', 'progress']}
                      /> */}
                    </View>
                    <View
                      style={{
                        // backgroundColor: 'white',
                        flexDirection: 'row',
                        width: '100%',
                        maxWidth: 600,
                        marginTop: 15,
                      }}
                    >
                      {/* <Text>
                        {`${translate('endpoint_photo')}:`}
                      </Text> */}
                      {Platform.OS === 'web' ? (
                        <View>
                          <form>
                            <input
                              type="file"
                              name="file"
                              id="file"
                              nesting="file" // eslint-disable-line
                              accept="image/*,.heic"
                              title={translate('endpoint_photo_upload')}
                              onChange={(e) => {
                                getAnalyticsService().report.event('endpointImageUploadWebAttempt', 'create');
                                this.setState({ uploading: true });
                                getUploader().handleWebUpload(
                                  'file',
                                  endpoint.data.uuid,
                                  onAddImage,
                                  null,
                                  (success) => {
                                    console.log('onComplete called');
                                    console.log(success);
                                    getAnalyticsService().report.event('endpointImageUploadWebSuccess', 'create');
                                    // onRefresh();
                                    this.setState({ uploading: false });
                                  },
                                  { app: endpoint.data.app, endpoint: endpoint.data.uuid },
                                  e
                                );
                              }}
                              style={{
                                width: '0.1px',
                                height: '0.1px',
                                opacity: '0',
                                overflow: 'hidden',
                                position: 'absolute',
                                zIndex: '-1',
                              }}
                            />
                            <label
                              id="label"
                              nesting="file" // eslint-disable-line
                              htmlFor="file"
                            >
                              {/* eslint-disable-line jsx-a11y/label-has-associated-control */}
                              <Button
                                // title={translate('endpoint_photo_upload')}
                                // title={translate('endpoint_photo_take')}
                                icon={(
                                  <Icon
                                    style={{ width: 24 }}
                                    name="camera"
                                    size={24}
                                    color="white"
                                  />
                                )}
                                containerStyle={styles.button.primaryContainer}
                                buttonStyle={styles.button.primary}
                                disabledStyle={styles.button.primaryDisabled}
                                titleStyle={styles.button.primaryTitle}
                                disabledTitleStyle={styles.button.primaryTitleDisabled}
                                disabled={isSubmitting || !isValid}
                              />
                            </label>
                          </form>
                        </View>
                      ) : (
                        <Button
                          // title={translate('endpoint_photo_upload')}
                          // title={translate('endpoint_photo_take')}
                          icon={(
                            <Icon
                              style={{ width: 24 }}
                              name="camera"
                              size={24}
                              color="white"
                            />
                          )}
                          containerStyle={styles.button.primaryContainer}
                          buttonStyle={styles.button.primary}
                          disabledStyle={styles.button.primaryDisabled}
                          titleStyle={styles.button.primaryTitle}
                          disabledTitleStyle={styles.button.primaryTitleDisabled}
                          onPress={(e) => {
                            getAnalyticsService().report.event('endpointImageUploadMobileAttempt', 'create');
                            this.setState({ uploading: true });
                            setTimeout(() => {
                              getUploader().handleMobilePhotoUpload(
                                'New endpoint image',
                                endpoint.data.uuid,
                                onAddImage,
                                null,
                                (success) => {
                                  console.log('onComplete called');
                                  console.log(success);
                                  getAnalyticsService().report.event('endpointImageUploadMobileSuccess', 'create');
                                  onRefresh();
                                  this.setState({ uploading: false });
                                },
                                { app: endpoint.data.app, endpoint: endpoint.data.uuid },
                                e
                              );
                            }, 0);
                          }}
                          disabled={isSubmitting || !isValid}
                        />
                      )}
                      {(endpoint.pp !== undefined && endpoint.pp.images !== undefined && endpoint.pp.images.length > 0) ? (
                        <View
                          style={{
                            flex: 1,
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            overflow: 'scroll',
                            marginRight: 8,
                          }}
                        >
                          {endpoint.pp.images.map((image) => (
                            <TouchableOpacity
                              key={image.uuid}
                              onPress={() => (
                                history.push(`/editimage/${endpoint.data.app}/${endpoint.data.uuid}/${image.uuid}`)
                              )}
                              style={{
                                alignSelf: 'center',
                                marginHorizontal: 3,
                              }}
                            >
                              {image.thumb ? (
                                <Image
                                  style={{
                                    width: 32,
                                    height: 32,
                                  }}
                                  source={{ uri: image.thumb }}
                                />
                              ) : (
                                <PendingImage
                                  imageStyle={{
                                    width: 32,
                                    height: 32,
                                  }}
                                  activityIndicatorStyle={{
                                    width: 32,
                                    height: 32,
                                  }}
                                  source={PublisherEndpointForm.getImage(image)}
                                />
                              )}
                            </TouchableOpacity>
                          ))}
                        </View>
                      ) : (
                        <Text style={{ alignSelf: 'center', flex: 1 }}>
                          {translate('create_endpoint_image')}
                        </Text>
                      )}
                      {/* <Button
                        title={translate('endpoint_photo_upload')}
                        icon={(
                          <Icon
                            name="paperclip"
                            size={24}
                            color="white"
                          />
                        )}
                        containerStyle={styles.button.primaryContainer}
                        buttonStyle={styles.button.primary}
                        disabledStyle={styles.button.primaryDisabled}
                        titleStyle={styles.button.primaryTitle}
                        disabledTitleStyle={styles.button.primaryTitleDisabled}
                        onPress={this.handlePhotoUpload}
                        disabled={isSubmitting}
                      /> */}
                    </View>
                  </>
                ) : (
                  <Text
                    style={{
                      alignSelf: 'center',
                      flex: 1,
                      width: '80%',
                      padding: 20,
                    }}
                  >
                    {translate('create_endpoint_hint')}
                  </Text>
                )}
              </View>
            </ScrollFading>
            <View style={styles.form.containerButtons}>
              <Button
                title={translate('button_cancel')}
                containerStyle={styles.button.secondaryContainer}
                buttonStyle={styles.button.secondary}
                disabledStyle={styles.button.secondaryDisabled}
                titleStyle={styles.button.secondaryTitle}
                disabledTitleStyle={styles.button.secondaryTitleDisabled}
                onPress={() => this.handleCancel(values)}
              />
              {onDel !== undefined && (
                <Button
                  title={translate('button_delete')}
                  containerStyle={styles.button.primaryContainer}
                  buttonStyle={styles.button.primary}
                  disabledStyle={styles.button.primaryDisabled}
                  titleStyle={styles.button.primaryTitle}
                  disabledTitleStyle={styles.button.primaryTitleDisabled}
                  onPress={() => this.handleDelete(values)}
                  disabled={!isValid || isSubmitting}
                  loading={isSubmitting}
                  loadingProps={{ size: 'small', color: 'white' }}
                />
              )}
              <Button
                title={endpoint.data.uuid !== 1 ? translate('button_save') : translate('button_add')}
                containerStyle={styles.button.primaryContainer}
                buttonStyle={styles.button.primary}
                disabledStyle={styles.button.primaryDisabled}
                titleStyle={styles.button.primaryTitle}
                disabledTitleStyle={styles.button.primaryTitleDisabled}
                onPress={handleSubmit}
                disabled={!isValid || isSubmitting}
                loading={isSubmitting}
                loadingProps={{ size: 'small', color: 'white' }}
              />
            </View>
          </KeyboardAvoidingView>
        </View>
        {(values.workingOnSomething || uploading) && (
          <View
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#ffffffc0',
            }}
          >
            <Text
              style={{
                marginVertical: 10,
              }}
            >
              {translate('wait')}
            </Text>
            <ActivityIndicator size="large" color={styles.primaryColor} />
          </View>
        )}
        {isDeleting && (
          <Modal
            style={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              alignSelf: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'transparent',
              borderWidth: 0,
            }}
            transparent
            presentationStyle="overFullScreen"
            visible
          >
            <View
              style={{
                flex: 1,
                position: 'relative',
                alignSelf: 'center',
                alignItems: 'center',
                alignContent: 'center',
                justifyContent: 'center',
              }}
            >
              <View
                style={{
                  position: 'relative',
                  alignSelf: 'center',
                  backgroundColor: 'white',
                  padding: 24,
                  paddingBottom: 12,
                  borderColor: styles.primaryColor,
                  borderWidth: 8,
                }}
              >
                <Text>{translate('endpoint_delete_modal')}</Text>

                <View
                  style={{
                    justifyContent: 'center',
                    flexDirection: 'row',
                    paddingTop: 24,
                  }}
                >
                  <Button
                    title={translate('button_cancel')}
                    containerStyle={styles.button.secondaryContainer}
                    buttonStyle={styles.button.secondary}
                    disabledStyle={styles.button.secondaryDisabled}
                    titleStyle={styles.button.secondaryTitle}
                    disabledTitleStyle={styles.button.secondaryTitleDisabled}
                    onPress={() => { this.setState({ isDeleting: false }); }}
                  />
                  <Button
                    title={translate('button_delete')}
                    containerStyle={styles.button.primaryContainer}
                    buttonStyle={styles.button.primary}
                    disabledStyle={styles.button.primaryDisabled}
                    titleStyle={styles.button.primaryTitle}
                    disabledTitleStyle={styles.button.primaryTitleDisabled}
                    onPress={this.handleDeleteReal}
                    disabled={!isValid || isSubmitting}
                    loading={isSubmitting}
                    loadingProps={{ size: 'small', color: 'white' }}
                  />
                </View>
              </View>
            </View>
          </Modal>
        )}
      </View>
    );
  };

  render() {
    const {
      app, endpoint, onDel, position,
    } = this.props;
    const { error } = this.state;

    if (!app || !endpoint
      || (onDel !== undefined && !endpoint.data)
      || (onDel === undefined && !position)) {
      console.log('position');
      console.log(position);
      return (
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ActivityIndicator size="large" color={styles.primaryColor} />
        </View>
      );
    }

    const { name, extraStay, size } = endpoint.data;
    let { lat, lon } = endpoint.data;

    if (!lat) { lat = position.latitude; }
    if (!lon) { lon = position.longitude; }

    return (
      <View
        style={{
          flex: 1,
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <Formik
          initialValues={{
            error,
            lat,
            lon,
            name: name || '',
            extraStay: extraStay || 0,
            size: size || 0,
          }}
          enableReinitialize
          validateOnMount
          onSubmit={(values, formikBag) => this.handleSave(values, formikBag)}
          validationSchema={validationSchema}
        >
          {this.renderForm}
        </Formik>
      </View>
    );
  }
}

PublisherEndpointForm.defaultProps = {
  onDel: undefined,
  onRefresh: () => null,
  position: undefined, // it's unset until it's autodetected
};

PublisherEndpointForm.propTypes = {
  position: AORTypes.Position,
  app: PropTypes.instanceOf(App).isRequired,
  endpoint: PropTypes.instanceOf(Endpoint).isRequired,
  onCancel: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDel: PropTypes.func,
  onRefresh: PropTypes.func,
  onAddImage: PropTypes.func.isRequired,
  onAddTrack: PropTypes.func.isRequired,
  getUploader: PropTypes.func.isRequired,
  getDirectionsService: PropTypes.func.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  direction: PropTypes.string.isRequired,
  // client: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default PublisherEndpointForm;
